export default (map, tier) => {
    const tierStyle = tier.getStyle();
    Object.keys(tierStyle.sources).forEach((sourceId) => {
        if (!map.getSource(sourceId)) {
            map.addSource(sourceId, tierStyle.sources[sourceId]);
        }
    });
};



// WEBPACK FOOTER //
// ./map/tier/styleUpdate/addSources.js